type PendingVerification = { phoneNumber: string; messageType: string | undefined; };

type PhoneVerifiedSubmissionResult =
  | { status: "created" }
  | { status: "verificationRequired"; verification: PendingVerification }
  | { status: "invalid"; errors: Record<string, string[]> }
  | { status: "redirect"; location: string };

type VerificationRequiredResponse = { verification: { phone_number: string; message_type: string | undefined; }; };
type FailedResponse = { errors?: Record<string, string[]>; next?: string; };

const HTTP_ACCEPTED = 202;

const submitRequiringPhoneVerification = async (requestPath: string, formData: FormData): Promise<PhoneVerifiedSubmissionResult> => {
  const details = {
    ...Object.fromEntries(formData),
    authenticity_token: (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement)?.content || "",
  };
  const result = await fetch(requestPath, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(details),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
  });

  if (result.status == HTTP_ACCEPTED) {
    const { verification } = await result.json() as VerificationRequiredResponse;

    return {
      status: "verificationRequired",
      verification: { phoneNumber: verification.phone_number, messageType: verification.message_type },
    };
  } else if (result.status < 300) {
    return { status: "created" };
  } else {
    const { errors, next } = await result.json() as FailedResponse;

    if (next) return { status: "redirect", location: next };

    return { status: "invalid", errors: errors ?? {} };
  }
}

export { submitRequiringPhoneVerification, PhoneVerifiedSubmissionResult, PendingVerification }
